import { render, staticRenderFns } from "./SomethingNotQuiteRight.vue?vue&type=template&id=1d81be8a&scoped=true&"
import script from "./SomethingNotQuiteRight.vue?vue&type=script&lang=ts&"
export * from "./SomethingNotQuiteRight.vue?vue&type=script&lang=ts&"
import style0 from "./SomethingNotQuiteRight.vue?vue&type=style&index=0&id=1d81be8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d81be8a",
  null
  
)

export default component.exports